import React, { useState, useEffect, ChangeEvent } from 'react';
import { Modal, Input, Button, Form, message } from 'antd';
import { getToken } from '@/utils/cookie';
import msgSuccess from '@/assets/images/login/msgSuccess.png';
import msgHint from '@/assets/images/login/msgHint.png';
import go_icon from '@/assets/images/login/go_icon.png';
import closeImage from '@/assets/images/login/inp_close.png';
import luckImage from '@/assets/images/login/code.png';
import { LuthInfoJson, approveList } from '../types';
import { apiGetPhoneCode, apiVerifyMessage } from '../server';
import './newDeviceModal.less';
import classnames from 'classnames';
import useCount from '@/hooks/count';
import { apiVerify } from '../server';
import NewDeviceHead from '../components/newDeviceHead';
import Fn from '@/utils/fn';
import { newWebSocket } from './bwWebSocket';
import { Websocket_key } from '@/apis/env';
import useSyncCallback from '@/hooks/useSyncCallback';
import { buildRequestPath } from '@/apis/request';

const COUNT_STATIC = 60;

interface prpsJson {
  modelShow: boolean;
  authInfo: LuthInfoJson;
  setModelShow: (val: boolean) => void;
  onConfirmBy: (val: number) => void;
  customMsg: (type: number, msgText: string) => void;
}

function NewDeviceModal(prop: prpsJson) {
  const { modelShow, setModelShow, authInfo, onConfirmBy, customMsg } = prop;
  const [form] = Form.useForm();
  const [current, setCurrent] = useState<number>(0);
  const [count, beginTimer, closeTimer] = useCount(COUNT_STATIC);
  const [canLogin, setCanLogin] = useState<boolean>(false);
  const prefixCode = <img src={luckImage} className="phone_icon" alt="" />;
  // const [websocketFn, setWebsocketFn] = useState<any>(null);
  // const [linkNum, steLinkNum] = useState<number>(0);
  const [wsToken, steWsToken] = useState<string>('');
  const msgSuccessImg = <img src={msgSuccess} alt="" />;
  const msgErrorImg = <img src={msgHint} alt="" />;
  const [messageApi, contextHolders] = message.useMessage();
  const [wsMsg, setWsMsg] = useState<string>('');
  const strVersion: any = localStorage.getItem('appv')?.replace(/&.+/, '');
  let numVersion = strVersion.replace(/[^0-9]/g, '');
  const mainVersion = numVersion.slice(0, 3);
  const isVersion = Number(mainVersion) >= 350;
  const status = Fn.compareVersion(strVersion || '', '5.0.1');
  const hasBoxAuth = status >= 0;
  const signObj = {
    device: 'pc',
    channel: '',
    appv: localStorage.getItem('appv')?.replace(/&.+/, ''),
    deviceOs: localStorage.getItem('os'),
    deviceId: localStorage.getItem('mac') || '',
    deviceBrand: '',
    deviceModel: '',
    netType: '',
    gameOwner: '',
    isSimulator: false
  };
  // 获取验证码
  const suffixCode = (
    <Button
      type="text"
      className={classnames('newDeviceModal-box_codeBtn', { login_container__codeBtn_num: count !== COUNT_STATIC })}
      onClick={onTimerClick}
      disabled={COUNT_STATIC !== count}
    >
      {count === COUNT_STATIC ? '获取验证码' : `${count}秒后重发`}
    </Button>
  );
  const customMsgs = (type: number, msgText: string) => {
    message.destroy();
    messageApi.open({
      type: 'success',
      content: msgText,
      icon: type === 1 ? msgSuccessImg : msgErrorImg,
      className: 'login-custom-messages-class',
      style: {
        marginTop: '15vh'
      }
    });
  };
  useEffect(
    () => () => {
      closeTimer();
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );
  useEffect(() => {
    // 回流认证： REFLUX_AUTH 新设备认证： DEVICE_AUTH 游戏导盒子认证： GAME_TO_BOX_AUTH
    const type = authInfo.loginAuthType;
    if (type === 'DEVICE_AUTH') {
      setCurrent(0);
    } else if (type === 'REFLUX_AUTH' || type === 'GAME_TO_BOX_AUTH') {
      setCurrent(3);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const translateWs = (urls: string, msg?: string) => {
    newWebSocket.init({
      url: urls, // 自己的ws 地址
      token: authInfo.token,
      onopen: (msg: any, data: any) => {
        console.log(msg, data);
      },
      onmessage: (data: any) => {
        console.log(data);
        setWsMsg(data);
        getMessage();
      },
      onclose: (data: any) => {
        console.log(data);
      }
    });
  };
  const getMessage = useSyncCallback(() => {
    if (current !== 2) return;
    const msg = wsMsg;
    const arr: any = msg.split(':');
    console.log(arr);
    if (arr.length && arr[0] === 'CONFIRM_AUTH') {
      onConfirmBy(2);
    } else if (arr.length && arr[0] === 'CANCEL_AUTH') {
      setCurrent(0);
      customMsgs(2, arr[1]);
    }
  });
  // 关闭弹框
  const handleCancel = () => {
    if (wsToken !== '') {
      closeWebSocket();
    }
    setModelShow(false);
  };
  function onTimerClick() {
    let typeText = 'new_device';
    if (current === 3) {
      if (authInfo.loginAuthType === 'REFLUX_AUTH') {
        typeText = 'reflux';
      } else {
        typeText = 'game_to_box';
      }
    }
    apiGetPhoneCode({ phone: '', account: authInfo.account, event: 1, type: typeText });
    customMsgs(1, '发送成功');
    beginTimer();
  }

  const handlePercentMatchCode = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const val = value ? value.replace(/[\D]/g, '') : value;
    form.setFieldsValue({
      code: val
    });
    if (val) {
      return setCanLogin(true);
    }
    setCanLogin(false);
  };

  const onSubmit = async () => {
    let formData = form.getFieldsValue();
    let res: any = await apiVerify({ phoneCode: formData.code, account: authInfo.account });
    if (!res.code) res = res.data;
    if (res.code === 200) {
      setModelShow(false);
      onConfirmBy(1);
    } else {
      customMsg(2, res.msg);
    }
  };

  const onVerifyType = async (id: number) => {
    if (id === 2) {
      let res: any = await apiVerifyMessage({
        pushType: 'AUTH',
        pushSource: 'auth',
        token: authInfo.token ? authInfo.token : ''
      });
      if (!res.code) res = res.data;
      if (res.code === 200) {
        setCurrent(id);
        getWebsocketUrls();
      } else {
        customMsg(2, res.msg);
        setModelShow(false);
      }
    } else {
      setCurrent(id);
    }
  };

  const getWebsocketUrls = async () => {
    if (wsToken === '') {
      const token = getToken();
      let url: any = {
        code: 'auth',
        deviceType: 'pc',
        deviceId: localStorage.getItem('mac') || '',
        appv: localStorage.getItem('appvOrigin'),
        boxAgent: Fn.headerBoxAgent(signObj)
      };
      // url = Fn.toSign(url, isVersion ? signObj : undefined);
      // 兼容旧证书
      if (!hasBoxAuth) {
        url = Fn.toSign(url, isVersion ? signObj : undefined);
      } else {
        const enSignObj = {
          code: 'auth',
          appv: localStorage.getItem('appv')?.replace(/&.+/, ''),
          deviceType: 'pc',
          deviceId: localStorage.getItem('mac') || '',
          token: token || ''
        };

        // 新签名
        const wsBaseUrl = Websocket_key.startsWith('http') ? Websocket_key : `https:${Websocket_key}`;
        const requestPath = buildRequestPath(new URL('/ws/pushMessage', wsBaseUrl), enSignObj, 'GET');
        console.log('requestPath', requestPath);
        const newSignObj = {
          method: 'GET',
          url: requestPath,
          ...enSignObj
        };

        const sign = await Fn.toSignV2({}, newSignObj);

        url = {
          'x-box-authorization': sign,
          ...enSignObj
        };
      }

      url = Fn.getWebsocketUrl(`${Websocket_key}/ws/pushMessage`, url);
      console.log(url);
      steWsToken(url);
      await translateWs(url);
    } else {
      console.log('已链接过 无须重复连接');
    }
  };

  const closeWebSocket = () => {
    newWebSocket && newWebSocket.close && newWebSocket.close();
    // websocketFn && websocketFn.close && websocketFn.close();
  };

  return (
    <Modal
      wrapClassName="newDeviceModal-box"
      visible={modelShow}
      width={460}
      zIndex={1}
      maskClosable={false}
      centered
      footer={null}
      onCancel={handleCancel}
      closeIcon={<span className="operation_close"></span>}
    >
      <NewDeviceHead
        headBtnType={current}
        setModelShow={setModelShow}
        setCurrent={setCurrent}
        handleCancel={handleCancel}
      />

      {(() => {
        switch (current) {
          case 0:
            return (
              <div className="newDeviceModal-box_content">
                <p className="newDeviceModal-box_hint">{authInfo.authOpenStatus ? approveList[0] : approveList[4]}</p>
                <div className="newDeviceModal-box_btnBox">
                  <p onClick={() => onVerifyType(1)}>
                    手机验证码验证 <img src={go_icon} alt="" />
                  </p>
                  {authInfo.authOpenStatus ? (
                    <p onClick={() => onVerifyType(2)}>
                      原设备授权登录 <img src={go_icon} alt="" />
                    </p>
                  ) : null}
                </div>
              </div>
            );
          case 1:
            return (
              <div className="newDeviceModal-box_content">
                <p style={{ height: '15px' }}></p>
                <Form form={form} onFinish={onSubmit}>
                  <Form.Item name="code" style={{ marginBottom: '0' }}>
                    <div className="newDeviceModal-box_btnBox">
                      <Input
                        className="check_input"
                        placeholder="请输入4位的验证码"
                        allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
                        prefix={prefixCode}
                        suffix={suffixCode}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => handlePercentMatchCode(e)}
                        maxLength={4}
                      ></Input>
                      <Button
                        className={canLogin ? 'newDeviceModal-box_submit' : 'newDeviceModal-box_submit disabled'}
                        htmlType="submit"
                      >
                        确认
                      </Button>
                    </div>
                  </Form.Item>
                </Form>
              </div>
            );
          case 2:
            return (
              <div className="newDeviceModal-box_content">
                <p className="newDeviceModal-box_hintBig">{approveList[3]}</p>
              </div>
            );
          case 3:
            return (
              <div className="newDeviceModal-box_content">
                <p className="newDeviceModal-box_hint" style={{ marginBottom: '0' }}>
                  {authInfo.loginAuthType === 'REFLUX_AUTH' ? approveList[1] : approveList[2]}
                </p>
                <Form form={form} onFinish={onSubmit}>
                  <Form.Item name="code" style={{ marginBottom: '0' }}>
                    <div className="newDeviceModal-box_btnBox">
                      <Input
                        className="check_input"
                        placeholder="请输入4位的验证码"
                        allowClear={{ clearIcon: <img className="phone_icon" src={closeImage} alt="" /> }}
                        prefix={prefixCode}
                        suffix={suffixCode}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => handlePercentMatchCode(e)}
                        maxLength={4}
                      ></Input>
                      <Button
                        className={canLogin ? 'newDeviceModal-box_submit' : 'newDeviceModal-box_submit disabled'}
                        htmlType="submit"
                      >
                        确认
                      </Button>
                    </div>
                  </Form.Item>
                </Form>
              </div>
            );
          default:
            return null;
        }
      })()}
      {contextHolders}
    </Modal>
  );
}

export default NewDeviceModal;
